import { HistoryEvent } from '@api/types';

export type IconParser = (event: HistoryEvent) => boolean;

class Config {
  constructor(readonly icon: string, readonly parser: IconParser) {}
}

class Store {
  private configs: Config[] = [];

  getIcon(event: HistoryEvent): Nullable<string> {
    for (const config of this.configs) {
      if (config.parser(event)) {
        return config.icon;
      }
    }
    return null;
  }

  register = (icon: string, parser: IconParser) => {
    this.configs.push(new Config(icon, parser));
  };
}

const store: Store = new Store();

export function registerIcons(onRegisterIcons: (register: PickOne<Store, 'register'>) => void): void {
  onRegisterIcons(store.register);
}

export function getHistoryIcon(event: HistoryEvent): Nullable<string> {
  return store.getIcon(event);
}
